import { inject, Injectable } from '@angular/core';
import { SelectApi } from './select.api';

@Injectable({
  providedIn: 'root'
})
export class SelectService {
  selectApi = inject(SelectApi);

  getDepartments() {
    return this.selectApi.GetDepartmentsForSelect();
  }

  getPositions(departmentId: string) {
    return this.selectApi.GetPositionsForSelect(departmentId);
  }

  getRoles() {
    return this.selectApi.GetRolesForSelect();
  }

  GetAccountingNumberDropdown() {
    return this.selectApi.GetAccountingNumberDropdown();
  }

  GetVendorListDropdown() {
    return this.selectApi.GetVendorListDropdown();
  }


  GetRequestTypeDropdown() {
    return this.selectApi.GetRequestTypeDropdown();
  }

  BranchDropdown() {
    return this.selectApi.GetBranchDropdown();
  }

  GetBranchByUserId(userId: string) {
    return this.selectApi.GetBranchByUserId(userId);
  }

  


}
